<div id="error-container" class="container">
  <mat-card appearance="outlined">
    <mat-card-title>An Error Has Occurred</mat-card-title>
    <mat-card-content>
      <p>An application error has occurred. This has been logged and reported to our technology team.</p>
      <p>We recommend that you use <a href="https://www.google.com/chrome/browser/" target="_blank">Google Chrome</a> to access our website.</p>
      <p>If the problem persists, please contact our customer support.</p>
    </mat-card-content>
  </mat-card>
</div>